var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thumbnails-range',{ref:"thumbnails",staticClass:"thumbnails-range",attrs:{"thumbnails":_vm.thumbnails,"thumbnail-size":_vm.thumbnailSize}})}
var staticRenderFns = []

export { render, staticRenderFns }